<app-toast></app-toast>

<div class="grid grid-cols-2 h-screen w-full mobile:flex">

    <div class="bg-primary-800 flex flex-col gap-5 mobile:hidden">
        <div class="flex self-center mt-[15%] mx-5">
            <div class="text-white max-w-[550px]">
                <h1 class="text-[38px] font-bold">{{ 'auth.welcome_to' | transloco }}</h1>
                <pre class="text-[16px] leading-6 whitespace-pre-line">{{ 'auth.platform_desc' | transloco }}</pre>

                <div class="flex items-center rounded-md w-[50px] h-1 gap-1 mt-5">
                    <div class="bg-white rounded-full h-1 w-3/4"></div>

                    <div class="flex items-center gap-1">
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-grow flex justify-end items-end">
            <img src="assets/images/signup-page/dashboard-example.png"
                alt="{{ 'auth.dashboard_example_image' | transloco }}"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
    </div>

    <div class="bg-white p-4 z-40 px-[5%] flex flex-col h-full mobile:px-7 mobile:w-screen">
        <div class="flex w-full items-center justify-between mobile:justify-center mobile:mt-10">
            <app-logo></app-logo>
        </div>

        <div class="flex-grow flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-5">
                <h1 class="text-5xl font-bold mobile:text-xl mobile:mt-[10vh]">{{ 'auth.sign_in_to_your_account' |
                    transloco }}</h1>
                <p class="mt-1 mobile:text-base">{{ 'auth.enter_your_email_sign_in' | transloco }}</p>

                <div class="mt-[10%]">
                    <app-labeled-input labelText="{{ 'auth.email_address' | transloco }}"
                        [iconSrc]="'assets/icons/sms.svg'" iconAltText="{{ 'auth.sms_icon' | transloco }}"
                        [inputId]="'email'" [inputType]="'email'" [(inputValue)]="emailInput"
                        [errorMessage]="emailInputError" autocomplete="email"></app-labeled-input>
                </div>
                <div class="mt-2">
                    <app-labeled-input labelText="{{ 'auth.password' | transloco }}" [iconSrc]="'assets/icons/lock.svg'"
                        iconAltText="{{ 'shared.lock_icon' | transloco }}" [inputId]="'password'"
                        [inputType]="'password'" [(inputValue)]="passwordInput" [errorMessage]="passwordInputError"
                        autocomplete="current-password"></app-labeled-input>
                </div>

                <div class="max-w-screen-sm w-full mt-8">
                    <app-primary-button buttonText="{{ 'auth.sign_in' | transloco }}" [isDisabled]="false"
                        (buttonClick)="signInClick()">
                    </app-primary-button>
                </div>

            </div>
            <div class="mt-6">
                <p class="font-normal"><a routerLink="/signup" class="text-primary hover:underline">{{
                        'auth.dont_have_account' | transloco }}</a> {{ 'auth.create_or_social_sign_in' | transloco }}
                </p>
                <p class="font-normal mt-2">
                    <a routerLink="/auth/reset-password" class="text-primary hover:underline">
                        {{ 'auth.forgot_password' | transloco }}
                    </a>
                    {{ 'auth.reset_your_password' | transloco }}
                </p>

            </div>

        </div>
    </div>


</div>